import React, { useEffect, useRef, useState } from 'react';
import { RiShareForwardLine } from 'react-icons/ri';
import {
  FacebookShareButton,
  WhatsappShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  FacebookMessengerShareButton,
} from 'react-share';
import {
  FaFacebook,
  FaWhatsapp,
  FaTwitter,
  FaSnapchat,
  FaLinkedin,
  FaFacebookMessenger,
  FaMailBulk,
} from 'react-icons/fa';
import { MdContentCopy } from 'react-icons/md';

import css from './ShareButton.module.css';
import { createResourceLocatorString } from '../../util/routes';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';
import { createSlug } from '../../util/urlHelpers';
// import { formatListingData } from '../../util/formattedListingData';
import Modal from '../Modal/Modal';
import { useDispatch, useSelector } from 'react-redux';
// import { manageDisableScrolling } from '../../ducks/UI.duck';
import classNames from 'classnames';
import axios from 'axios';
import { apiBaseUrl } from '../../util/api';

export const DISABLE_SCROLLING = 'app/UI/DISABLE_SCROLLING';
export const manageDisableScrolling = (componentId, disableScrolling) => ({
  type: DISABLE_SCROLLING,
  payload: { componentId, disableScrolling },
});
const getUrlByListing = (listing, routeConfiguration, shareLSHLink) => {
  const title = listing?.attributes?.title;

  const origin = typeof window !== 'undefined' && window.location.origin;
  const pagename = 'ListingPage';
  const listingPath = createResourceLocatorString(
    pagename,
    routeConfiguration,
    {
      slug: createSlug(title),
      id: listing?.id?.uuid,
    },
    {}
  );
  const link = origin + listingPath;
  return link;
};
const MacShareComponent = props => {
  const { listing, shareLSHLink, divProps, routeConfiguration } = props;
  const [isCopySuccess, setIsCopySuccess] = useState(false);
  const inputRef = useRef();
  const urlShr = listing?.id?.uuid && getUrlByListing(listing, routeConfiguration, shareLSHLink);
  const currentUser = useSelector(state => state.user?.currentUser);

  const trackShare = channel => {
    if (currentUser?.id?.uuid) {
      axios.post(
        `${apiBaseUrl()}/api/track/share`,
        {
          userId: currentUser.id.uuid,
          listingId: listing?.id?.uuid,
          shareChannel: channel,
        },
        { withCredentials: true }
      ).catch(() => {});
    }
  };

  return (
    <div className={css.shareIconDiv} {...divProps}>
      <div className={css.buttonWrapper} onClick={() => trackShare('whatsapp')}>
        <WhatsappShareButton url={urlShr}>
          <FaWhatsapp />
        </WhatsappShareButton>
        <div className={css.iconName}>Whatsapp</div>
      </div>
      <div className={css.buttonWrapper} onClick={() => trackShare('facebook')}>
        <FacebookMessengerShareButton url={urlShr}>
          <FaFacebookMessenger />
        </FacebookMessengerShareButton>
        {/* </div> */}
        <div className={css.iconName}>Facebook</div>
      </div>
      {/* <div className={css.buttonWrapper}>
        <FacebookShareButton url={urlShr}>
          <FaFacebook />
        </FacebookShareButton>
        <div className={css.iconName}>Facebook</div>
      </div> */}
      <div className={css.buttonWrapper} onClick={() => trackShare('twitter')}>
        <TwitterShareButton url={urlShr}>
          <FaTwitter />
        </TwitterShareButton>
        <div className={css.iconName}>X</div>
      </div>
      <div className={css.buttonWrapper} onClick={() => trackShare('linkedin')}>
        <LinkedinShareButton url={urlShr}>
          <FaLinkedin />
        </LinkedinShareButton>
        <div className={css.iconName}>LinkedIn</div>
      </div>
      <div className={css.buttonWrapper} onClick={() => trackShare('email')}>
        <a
          href={`https://mail.google.com/mail/?view=cm&su=""&body=${encodeURIComponent(urlShr)}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaMailBulk />
        </a>
        <div className={css.iconName}>Email</div>
      </div>
      <div className={css.buttonWrapper}>
        <div className={css.linkCopyShare}>
          <input type="text" ref={inputRef} value={urlShr} readOnly className={css.linkCopyBox} />
          <button
            className={css.cpybtn}
            type="button"
            onClick={async e => {
              try {
                trackShare('copy');
                const textToCopy = inputRef.current.value;
                await navigator.clipboard.writeText(textToCopy);
                setIsCopySuccess(true);
                const closeDiv = setTimeout(() => {
                  setIsCopySuccess(false);
                }, 2000);
                // Clear timeout on unmount
                return () => clearTimeout(closeDiv);
              } catch (err) {
                console.error('Failed to copy!', err);
                setIsCopySuccess(false);
              }
            }}
          >
            <MdContentCopy />
          </button>
        </div>
        <div className={css.iconName}>{isCopySuccess ? 'Link Copied!' : 'Copy Link'}</div>
      </div>
    </div>
  );
};

const ShareButton = props => {
  const { listing, className, buttonText, id = 'share-button', shareLSHLink } = props;
  const routeConfiguration = useRouteConfiguration();
  const dispatch = useDispatch();
  const onManageDisableScrolling = (a, b) => dispatch(manageDisableScrolling(a, b));
  const [showAppleOptions, setShowAppleOptions] = useState(false);
  const [isMac, setIsMac] = useState(false);
  const wrapperDivRef = useRef();
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const handleResize = () => setIsDesktop(window.innerWidth > 991);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const checkMac = () => {
      return (
        navigator.platform.indexOf('Mac') > -1 ||
        navigator.userAgentData?.platform.indexOf('Mac') > -1
      );
    };
    setIsMac(checkMac());
  }, []);
  useEffect(() => {
    if (showAppleOptions && wrapperDivRef.current) {
      wrapperDivRef.current.focus();
    }
  }, [showAppleOptions]);
  const buttonClass = classNames(css.shareButton, className);
  const currentUser = useSelector(state => state.user?.currentUser);
  const handleShare = async () => {
    if (!listing?.id?.uuid) return;
    const title = listing?.attributes?.title;
    const link = getUrlByListing(listing, routeConfiguration, shareLSHLink);
    const canUseNavigatorShare = typeof navigator !== 'undefined' && !!navigator.share;

    if (isMac && isDesktop) {
      setShowAppleOptions(true);
    } else if (canUseNavigatorShare) {
      try {
        await navigator.share({
          title: title,
          text: title,
          url: link,
        });
        if (currentUser?.id?.uuid) {
          axios.post(
            `${apiBaseUrl()}/api/track/share`,
            {
              userId: currentUser.id.uuid,
              listingId: listing?.id?.uuid,
              shareChannel: 'native',
            },
            { withCredentials: true }
          ).catch(() => {});
        }
        console.log('Content shared successfully');
      } catch (error) {
        console.error('Error sharing:', error);
      }
    } else {
      setShowAppleOptions(true);
    }
  };
  const handleDivBlur = e => {
    if (!wrapperDivRef.current.contains(e.relatedTarget)) setShowAppleOptions(false);
  };
  return true ? ( //isMac
    <>
      <button
        type="button"
        className={buttonClass}
        id={id}
        // onClick={e => {
        //   const rect = e.target.getBoundingClientRect();
        //   const allElems = Array.from(document.getElementsByClassName(css.shareButton)).map(
        //     e => e.id
        //   );
        //   const currIdx = allElems.indexOf(id);
        //   const element = document.getElementsByClassName(css.additionalSecondDivClassname)[
        //     currIdx || 0
        //   ];
        //   if (element) {
        //     element.style.top = `${rect.top - 20}px`;
        //     element.style.left = `${rect.left + rect.width / 2}px`;
        //   }
        //   setShowAppleOptions(true);
        // }}
        onClick={e => handleShare()}
        // onBlur={e => setShowAppleOptions(false)}
      >
        {buttonText}
      </button>
      <Modal
        id={`${id}-modal`}
        showLogo={false}
        isOpen={showAppleOptions}
        // isOpen={true}
        onManageDisableScrolling={onManageDisableScrolling}
        additionalSecondDivClassname={css.additionalSecondDivClassname}
        onClose={() => {
          setShowAppleOptions(false);
        }}
        modalContainerClassName={css.shareModalContainer}
        modalScrollLayerClassName={css.shareModelScrollLayer}
      >
        <MacShareComponent
          listing={listing}
          shareLSHLink={shareLSHLink}
          divProps={{ tabIndex: 1, ref: wrapperDivRef }}
          routeConfiguration={routeConfiguration}
        />
      </Modal>
    </>
  ) : (
    <button type="button" id={id} className={buttonClass} onClick={handleShare}>
      {buttonText}
    </button>
  );
};

export default ShareButton;
